import { render, staticRenderFns } from "./dialogNoodVideo.vue?vue&type=template&id=8d236746&scoped=true"
import script from "./dialogNoodVideo.vue?vue&type=script&lang=js"
export * from "./dialogNoodVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d236746",
  null
  
)

export default component.exports